import deepReorder from './deepReorder';
import deepEdit from './deepEdit';

const toggleButton = ({ toggle, attribute, navigation, item }) => {
  const { id } = item;
  let newNavigation;

  // if we are setting an item as a button
  if (toggle) {
    // and it is being set as the secondary button AND there is already a primary button
    if (attribute === 'isSecondary' && navigation[navigation.length - 1].isPrimary) {
      newNavigation = deepReorder(navigation, id, (navigationItem, navigationItems) => {
        const primaryItem = navigationItems.splice(navigationItems.length - 1);

        // move the new secondary button as the second to last item, with the primary as last
        return [
          ...navigationItems,
          { ...navigationItem, [attribute]: !navigationItem[attribute] },
          ...primaryItem,
        ];
      });
    } else {
      // otherwise, move the new button all the way to the bottom
      newNavigation = deepReorder(navigation, id, (navigationItem, navigationItems) => ([
        ...navigationItems,
        { ...navigationItem, [attribute]: !navigationItem[attribute] },
      ]));
    }
  // but if we are removing the primary button and there is already a secondary
  } else if (attribute === 'isPrimary' && navigation[navigation.length - 2]?.isSecondary) {
    newNavigation = deepReorder(navigation, id, (navigationItem, navigationItems) => {
      const secondaryItem = navigationItems.splice(navigationItems.length - 1, 1);

      // move the previous primary item to second last, with the existing secondary as last
      return [
        ...navigationItems,
        { ...navigationItem, [attribute]: !navigationItem[attribute] },
        ...secondaryItem,
      ];
    });
  } else {
    // otherwise just remove the button designation from the item
    newNavigation = deepEdit(navigation, id, oldNavigationItem => ({
      ...oldNavigationItem,
      [attribute]: !oldNavigationItem[attribute],
    }));
  }

  return newNavigation;
};

export default toggleButton;
